module.exports = __webpack_public_path__ + "img/google-play-badge-en.b37d0b93.png";